<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'EntrepriseBlogFormationProfessionnelleFonctionnement'
});
</script>
<template>
  <ka-container
    code="article-fonctionnement-de-la-formation-p"
    :data="page.$info.articleFonctionnementDeLaFormationP">
    <!-- Article Template -->
    <ka-container code="article-template">
      <!-- Theme -->
      <ka-container
        code="theme"
        :options="{ hidden: null }">
        <ka-text code="organisation">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.theme.organisation.value', `Organisation`)" />
        </ka-text>
        <ka-text code="text-1">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.theme.text1.value', `Organisation`)" />
        </ka-text>
      </ka-container>
      <!-- Gauche -->
      <ka-container code="gauche">
        <ArticleEnteteEnBref
          instance-class="article-entete-en-bref--p80"
          article-title="Formation professionnelle, une opportunité pour les start-up, TPE et PME 🚀"
          subtitle=""
          in-short="Apparue en France suite aux manifestations de mai 1968, <strong>la formation professionnelle </strong>ne cesse d’évoluer. La dernière grande réforme (1er janvier 2019) a permis de faciliter l’accès à la formation notamment pour les <strong>entreprises de moins de 50 salariés</strong>.<br> <br>Aujourd’hui grands chouchous des<strong> dispositifs finançables à 100%, </strong>les<strong> </strong>start-up, TPE et PME ne profitent pourtant que très rarement de leurs avantages. Mal renseignées voire non renseignées, aujourd’hui, une majorité de dirigeants n’ont encore jamais mis en place de formation au sein de leur équipe. <strong>La formation professionnelle</strong> change beaucoup et souvent. Chaque dispositif, convention collective et OPCO possèdent ses règles. Dans cet article nous vous présenterons les bases sur lesquelles reposent tout le système de <strong>la formation professionnelle</strong>." />
        <ka-text code="sommaire">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.sommaire.value', `Sommaire`)" />
        </ka-text>
        <ka-text code="sous-titre-sommaire">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.sousTitreSommaire.value', `La formation professionnelle en détails `)" />
        </ka-text>
        <!-- Sommaire -->
        <ka-container code="container-1">
          <!-- Titre section -->
          <ka-container code="titre-section">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="conteneur-rond-bleu"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="rond-bleu" />
            </ka-container>
            <ka-text code="quest-ce-que-cest">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.titreSection.questCeQueCest.value', `Qu’est ce que c’est ?`)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-2">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-3"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-4" />
            </ka-container>
            <ka-text code="les-acteurs-de-la-formation">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.container2.lesActeursDeLaFormation.value', `Les acteurs de la formation professionnelle`)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-5">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-6"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-7" />
            </ka-container>
            <ka-text code="comment-est-elle-financee">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.container5.commentEstElleFinancee.value', `Comment est-elle financée ? `)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-8">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-9"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-10" />
            </ka-container>
            <ka-text code="les-opco-qui-sont-ils">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.container8.lesOpcoQuiSontIls.value', `Les OPCO, qui sont-ils ?`)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-11">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-12"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-13" />
            </ka-container>
            <ka-text code="qui-assure-ces-formations">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.container11.quiAssureCesFormations.value', `Qui assure ces formations ? `)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-14">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-15"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-16" />
            </ka-container>
            <ka-text code="quest-ce-que-la-certification">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.container14.questCeQueLaCertification.value', `Qu’est-ce que la certification Qualiopi ?  `)" />
              <template #xs>
                <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container1.container14.questCeQueLaCertification.xs.value', `Qu’est-ce que la certification Qualiopi ?`)" />
              </template>
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-2">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text2.value', `L’accès à la formation pour les start-up, TPE e PME`)" />
        </ka-text>
        <!-- Sommaire -->
        <ka-container code="container-17">
          <!-- Titre section -->
          <ka-container code="container-18">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-19"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-20" />
            </ka-container>
            <ka-text code="des-financements-dedies">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container17.container18.desFinancementsDedies.value', `Des financements dédiés aux petites entreprises`)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-21">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-22"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-23" />
            </ka-container>
            <ka-text code="les-regles-a-connaitre">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container17.container21.lesReglesAConnaitre.value', `Les règles à connaître`)" />
            </ka-text>
          </ka-container>
          <!-- Titre section -->
          <ka-container code="container-24">
            <!-- Conteneur-rond-bleu -->
            <ka-container
              code="container-25"
              inner>
              <!-- Rond-bleu -->
              <ka-container code="container-26" />
            </ka-container>
            <ka-text code="comment-acceder-a-ces">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container17.container24.commentAccederACes.value', `Comment accéder à ces budgets ?`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Image`
          }"
          value="https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwyOXx8d29ya3xlbnwwfHx8fDE2ODY3NDUzODl8MA&ixlib=rb-4.0.3&q=80&w=1080" />
        <ka-text code="grand-titre">
          <h2 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.grandTitre.value', `La formation professionnelle en détails`)" />
        </ka-text>
        <ka-text code="tire">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.tire.value', `Qu’est ce que c’est ? `)" />
        </ka-text>
        <ka-text code="il-sagit-dun-outil">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.ilSagitDunOutil.value', page.$constants.ilSagitDunOutil)" />
        </ka-text>
        <ka-text code="une-action-de-formation">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.uneActionDeFormation.value', page.$constants.uneActionDeFormation)" />
        </ka-text>
        <ka-text code="cette-nouvelle-definition">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.cetteNouvelleDefinition.value', `Cette nouvelle définition a permis de donner naissance à de nouvelles méthodes pédagogiques car depuis cette réforme, les types de formations qui peuvent être financés peuvent prendre de multiples formes.<br> <br><strong>Aujourd'hui une formation peut être :</strong>`)" />
        </ka-text>
        <!-- Mots clés -->
        <ka-container code="mots-cles">
          <ka-text code="a-distance">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.motsCles.aDistance.value', `À distance`)" />
          </ka-text>
          <ka-text code="sequencee">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.motsCles.sequencee.value', `Séquencée`)" />
          </ka-text>
          <ka-text code="individualisee">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.motsCles.individualisee.value', `Individualisée`)" />
          </ka-text>
          <ka-text code="sur-mesure">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.motsCles.surMesure.value', `Sur-mesure`)" />
          </ka-text>
          <ka-text code="en-situation-de-travail">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.motsCles.enSituationDeTravail.value', `En situation de travail`)" />
          </ka-text>
          <ka-text code="basee-sur-une-problematique">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.motsCles.baseeSurUneProblematique.value', `Basée sur une problématique spécifique`)" />
          </ka-text>
        </ka-container>
        <ka-text code="en-pratique">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.enPratique.value', `En pratique :<br> <br><strong>Un alternant rejoint votre entreprise en tant que webdesigner mais son supérieur n'a pas exactement la compétence métier, il est développeur front-end.</strong><br> <br><span style='background-color:transparent;color:#000000;'>👉 Vous pouvez mettre en place une formation en entreprise au cours de laquelle un expert suit chaque semaine le travail de votre alternant pour qu'il gagne en autonomie et en compétences. </span><br> <br> <br><span style='background-color:transparent;color:#000000;'><strong>L'équipe s'agrandit et votre commercial, autrefois  seul dans ce pôle, a maintenant une équipe de trois personnes à manager. </strong></span><br> <br><span style='background-color:transparent;color:#000000;'><strong>👉</strong> Vous pouvez mettre en place une formation sous forme de coaching individuel ou collectif avec un expert en management d'équipe commerciale. </span>`)" />
        </ka-text>
        <ka-text code="text-3">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text3.value', `Les acteurs de la formation professionnelle`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container-27">
          <!-- Container 1 -->
          <ka-container code="container-28">
            <ka-text code="beneficiaires-de-formations">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container27.container28.beneficiairesDeFormations.value', `<p><strong>Bénéficiaires de formations professionnelles : </strong></p><p> </p><ul><li>Les entreprises,</li><li>Les dirigeants d’entreprises,</li><li>Les salariés,</li><li>Les demandeurs d’emploi,</li><li>Les jeunes</li><li>Autre…</li></ul>`)" />
            </ka-text>
          </ka-container>
          <!-- Container 1 -->
          <ka-container code="container-29">
            <ka-text code="prestataires-contribuant">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container27.container29.prestatairesContribuant.value', `<strong>Prestataires contribuant au développement de compétences :</strong><br> <p><ul><li>Les organismes de formation</li><li>Centres de bilan de compétences ou de VAE (Validation des acquis de l’expérience…)</li><li>Les centres de formation</li><li>Autre…</li></ul><p> </p>`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="text-4">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text4.value', `Comment la formation professionnelle est-elle financée ?`)" />
        </ka-text>
        <!-- Conteneur -->
        <ka-container code="conteneur">
          <!-- Deroule -->
          <ka-container
            code="deroule"
            :options="{
              click: page.derouleClick,
              $state: { selected: $isEqual(page.$elements['question-1']?.style.hidden, page.$constants.question1Hidden) }
            }"
            :selected="{ click: page.derouleClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="titre">
              <ka-text code="k-1-les-entreprises">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.deroule.titre.k1LesEntreprises.value', `1.   Les entreprises s’acquittent chaque année d’une contribution unique dont le montant est calculé en fonction de leur masse salariale. `)" />
              </ka-text>
              <ka-icon
                code="icone-developper-4"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
          </ka-container>
          <!-- Question 1 -->
          <ka-container
            code="question-1"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <!-- Tableau -->
            <ka-container code="tableau">
              <!-- Ligne 1 -->
              <ka-container code="ligne-1">
                <ka-text code="effectif-moyen-de-lentreprise">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.question1.tableau.ligne1.effectifMoyenDeLentreprise.value', `Effectif moyen de l'entreprise`)" />
                </ka-text>
                <ka-text code="taux-de-cotisation">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.question1.tableau.ligne1.tauxDeCotisation.value', `Taux de cotisation (entreprises générales)`)" />
                </ka-text>
              </ka-container>
              <!-- Ligne 2 -->
              <ka-container code="ligne-2">
                <ka-text code="jusqua-10-salaries">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.question1.tableau.ligne2.jusqua10Salaries.value', `Jusqu'à 10 salariés`)" />
                </ka-text>
                <ka-text code="k-055">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.question1.tableau.ligne2.k055.value', `0,55%`)" />
                </ka-text>
              </ka-container>
              <!-- Ligne 3 -->
              <ka-container code="ligne-3">
                <ka-text code="a-partir-de-11-salaries">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.question1.tableau.ligne3.aPartirDe11Salaries.value', `À partir de 11 salariés`)" />
                </ka-text>
                <ka-text code="k-100">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.conteneur.question1.tableau.ligne3.k100.value', `1,00%`)" />
                </ka-text>
              </ka-container>
            </ka-container>
          </ka-container>
        </ka-container>
        <!-- Conteneur -->
        <ka-container code="container-30">
          <!-- Deroule -->
          <ka-container
            code="container-31"
            :options="{ click: page.container31Click }"
            :selected="{ click: page.container31ClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="container-32">
              <ka-text code="k-2-lurssaf-collecte">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container30.container31.container32.k2LurssafCollecte.value', `2.   L’URSSAF collecte les fonds.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
        <!-- Conteneur -->
        <ka-container code="container-33">
          <!-- Deroule -->
          <ka-container
            code="container-34"
            :options="{
              click: page.container34Click,
              $state: { selected: $isEqual(page.$elements['container-36']?.style.hidden, page.$constants.question1Hidden) }
            }"
            :selected="{ click: page.container34ClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="container-35">
              <ka-text code="k-3-mutualises-ces">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container34.container35.k3MutualisesCes.value', `3.   Mutualisés, ces fonds sont ensuite répartis entre les différents acteurs du financement de la formation pro par France Compétences. `)" />
              </ka-text>
              <ka-icon
                code="icon-1"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
          </ka-container>
          <!-- Question 1 -->
          <ka-container
            code="container-36"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <!-- Tableau -->
            <ka-container code="container-37">
              <!-- Colonne 1 -->
              <ka-container code="colonne-1">
                <ka-text code="pole-emploi">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container37.colonne1.poleEmploi.value', `<span style='background-color:transparent;color:#000000;'><strong>Pôle emploi</strong></span>`)" />
                </ka-text>
                <ka-text code="gestion-et-financement">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container37.colonne1.gestionEtFinancement.value', `<span style='background-color:transparent;color:#000000;'>Gestion et financement des demandeurs d’emploi</span>`)" />
                </ka-text>
              </ka-container>
              <!-- Colonne 1 -->
              <ka-container code="container-38">
                <ka-text code="caisse-des-depots">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container37.container38.caisseDesDepots.value', `<span style='background-color:transparent;color:#000000;'><strong>Caisse des dépôts et consignations</strong></span>`)" />
                </ka-text>
                <ka-text code="text-5">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container37.container38.text5.value', `Gestion et financement du CPF (Compte personnel de formation)`)" />
                </ka-text>
              </ka-container>
              <!-- Colonne 1 -->
              <ka-container code="container-39">
                <ka-text code="operateurs-de-competences">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container37.container39.operateursDeCompetences.value', `<span style='background-color:transparent;color:#000000;'><strong>Opérateurs de compétences</strong></span>`)" />
                </ka-text>
                <ka-text code="financement-de-lalternance">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container37.container39.financementDeLalternance.value', `Financement de l’alternance, des formations des salariés des TPE-PME et l’appui des branches professionnelles dans leurs missions `)" />
                </ka-text>
              </ka-container>
            </ka-container>
            <!-- Tableau -->
            <ka-container code="container-40">
              <!-- Colonne 1 -->
              <ka-container code="container-41">
                <ka-text code="commission-paritaires">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container40.container41.commissionParitaires.value', `<span style='background-color:transparent;color:#000000;'><strong>Commission paritaires interprofessionnelles régionales</strong></span>`)" />
                </ka-text>
                <ka-text code="financement-des-projets">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container40.container41.financementDesProjets.value', `Financement des projets de transition professionnelle `)" />
                </ka-text>
              </ka-container>
              <!-- Colonne 1 -->
              <ka-container code="container-42">
                <ka-text code="operateurs-du-conseil">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container40.container42.operateursDuConseil.value', `<span style='background-color:transparent;color:#000000;'><strong>Opérateurs du Conseil en évolution professionnelle</strong></span>`)" />
                </ka-text>
                <ka-text code="delivrent-un-conseil">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container40.container42.delivrentUnConseil.value', `Délivrent un conseil en évolution professionnelle aux actifs occupés du secteur privé`)" />
                </ka-text>
              </ka-container>
              <!-- Colonne 1 -->
              <ka-container code="container-43">
                <ka-text code="conseils-regionaux">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container40.container43.conseilsRegionaux.value', `<span style='background-color:transparent;color:#000000;'><strong>Conseils régionaux</strong></span>`)" />
                </ka-text>
                <ka-text code="assurent-le-financement">
                  <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container33.container36.container40.container43.assurentLeFinancement.value', `Assurent le financement des centres de formation d’apprentis et le développement économique territorial `)" />
                </ka-text>
              </ka-container>
            </ka-container>
          </ka-container>
        </ka-container>
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 1`
          }"
          value="https://ucarecdn.com/06bdead4-74a7-4bf3-b74b-e5324d2c0ae6/" />
        <!-- En savoir + FC -->
        <ka-container code="en-savoir-fc">
          <!-- Deroule -->
          <ka-container
            code="container-44"
            :options="{
              click: page.container44Click,
              $state: { selected: $isEqual(page.$elements['texte-developpe']?.style.hidden, page.$constants.texteDeveloppeHidden) }
            }"
            :selected="{ click: page.container44ClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="container-45">
              <ka-text code="en-savoir-plus-sur">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.enSavoirFc.container44.container45.enSavoirPlusSur.value', `En savoir plus sur<span style='color:#1100A2FF;'> France Compétences</span>`)" />
                <template #xs>
                  <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.enSavoirFc.container44.container45.enSavoirPlusSur.xs.value', `En savoir plus sur <span style='color:#1100A2FF;'><strong>France Compétences</strong></span>`)" />
                </template>
              </ka-text>
              <ka-icon
                code="icon-2"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
          </ka-container>
          <!-- Texte developpe -->
          <ka-container
            code="texte-developpe"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <ka-text code="france-competences">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.enSavoirFc.texteDeveloppe.franceCompetences.value', `France compétences est la seule instance de gouvernance nationale de <strong>la formation professionnelle et de l’apprentissage</strong>.<br> <br>Créée le 1er janvier 2019, par la loi Avenir professionnel du 5 septembre 2018, France compétences a pour mission d’assurer le financement, la régulation, le contrôle et l’amélioration du système de la <strong>formation professionnelle et de l’apprentissage</strong>.<br> <br>Son action permet le développement des compétences, l’acquisition de certifications ainsi qu’une égalité d’accès à la formation professionnelle de l’ensemble des actifs.`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Container  à savoir -->
        <ka-container code="container-a-savoir">
          <ka-text code="a-savoir">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.containerASavoir.aSavoir.value', `À savoir `)" />
          </ka-text>
          <ka-text code="depuis-2022-tout">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.containerASavoir.depuis2022Tout.value', `<strong>Depuis 2022</strong>, tout devait être simplifié avec <strong>UNE</strong> contribution <strong>UNIQUE</strong> prélevée <strong>AUTOMATIQUEMENT</strong> par l’URSSAF pour qu’elle redistribue ensuite la somme des contributions mutualisées aux différents acteurs de la formation.<br> <br>Néanmoins, <strong>certaines conventions collectives</strong> comme par exemple Syntec - bureaux d'études techniques [IDCC 1486] ont fixé un taux supérieur à celui fixé par la loi.<br> <br>Conséquence ? Les entreprises rattachées à ces conventions collectives doivent verser une première cotisation à l’URSSAF (prélèvement automatique après transmission de la DSN) et une seconde auprès de<strong> leur OPCO </strong>directement sur leur espace OPCO en ligne.`)" />
          </ka-text>
          <ka-image
            code="image-2"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image 1`
            }"
            value="https://ucarecdn.com/dcb7066e-57c9-45f4-876e-afb07185d2d3/" />
        </ka-container>
        <ka-text code="text-6">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text6.value', ` Les OPCO, qui sont-ils ?`)" />
          <template #xs>
            <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text6.xs.value', `Les OPCO, qui sont-ils ?`)" />
          </template>
        </ka-text>
        <ka-text code="depuis-le-1-er-avril">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.depuisLe1ErAvril.value', `Depuis le 1er avril 2019, onze OPérateurs de COmpétences (OPCO), organismes chargés d’accompagner<strong> la formation professionnelle</strong>, ont été agréés. (Leurs missions étaient précédemment assumées par les OPCA, bien plus nombreux).<br> <br>Leur rôle est de soutenir et d’accompagner les entreprises dans le domaine de<strong> la gestion des compétences et de la formation</strong>. <br> <br>Chaque entreprise ne peut dépendre que d’un OPCO selon <strong>sa branche d’activité</strong>. Effectivement, ces 11 OPCO sont divisés d’après une logique de branches professionnelles basée sur la convergence <strong>des besoins en compétences des entreprises</strong>.`)" />
        </ka-text>
        <!-- Container 15 -->
        <ka-container code="container-46" />
        <!-- Les OPCO -->
        <ka-container code="les-opco">
          <ka-image
            code="image-3"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/c155bf47-1a7b-437d-b4f8-0dfeef70344d/" />
          <ka-image
            code="image-4"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/e4dc5b1a-53c5-47b2-b45e-d92c02f7773c/" />
          <ka-image
            code="image-5"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/9f163ba2-9047-412f-a5aa-098f94f53d36/logo-bleu (2).svg" />
          <ka-image
            code="image-6"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/89e33057-6c9f-470f-a1ec-6895b03c669a/" />
        </ka-container>
        <!-- Les OPCO -->
        <ka-container code="container-47">
          <ka-image
            code="image-7"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/b6e0249a-91a4-40cb-9abe-6253fea89582/"
            inner />
          <ka-image
            code="image-8"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/05cfae31-3023-4bec-9493-4ea004f05cc1/" />
          <ka-image
            code="image-9"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/53b65383-75e0-46e0-af14-70dfc1e2a82a/" />
          <ka-image
            code="image-10"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/4eda597e-e309-4862-871f-dad49c36523f/logo (1).svg" />
        </ka-container>
        <!-- Les OPCO -->
        <ka-container code="container-48">
          <ka-image
            code="image-11"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/56b80858-e66d-48c3-a270-2e7998b7caf9/" />
          <ka-image
            code="image-12"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/79202420-ed2b-453e-b997-14330d461ac6/" />
          <ka-image
            code="image-13"
            :options="{
              animationIn: `fadeIn`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              alt: `Image`
            }"
            value="https://ucarecdn.com/54581fee-4945-499d-899f-13827e181358/" />
        </ka-container>
        <ka-text code="ces-operateurs-de-competences">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.cesOperateursDeCompetences.value', `Ces opérateurs de compétences ont pour missions de financer l’apprentissage, d’aider les branches à construire les certifications professionnelles et d’accompagner les entreprises à définir leurs besoins en formation.`)" />
        </ka-text>
        <ka-text code="exemple-l-opco">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.exempleLOpco.value', `<span style='color:#616161;'><i>Exemple : l'OPCO Atlas accompagne les entreprises de</i></span><span style='color:#616161FF;'><i> 13 branches professionnelles des services financiers et du conseil, réparties en 4 grandes familles d'activité : Assurance - Banque et finance - Conseil (dont la branche des bureaux d'études techniques qui regroupe 97% d'entreprises de moins de 50 salariés) et </i></span><span style='color:#616161;'><i>Expertise comptable et commissariat aux comptes. </i></span><br> <br><span style='color:#616161;'><i> Les dispositifs de financement seront donc potentiellement orientés vers des formations en adéquation avec les évolutions technologiques du quotidien des salariés.</i></span>`)" />
        </ka-text>
        <BlocConnaitreMonOpco instance-class="bloc-connaitre-mon-opco--p80" />
        <BlocDropDownDefinitionCodeApe
          instance-class="bloc-drop-down-definition-code-ape--p80"
          title="Votre code APE (activité principale exercée) " />
        <BlocDropDownDefinitionConventionCo
          instance-class="bloc-drop-down-definition-convention-co--p80"
          title="Votre convention collective" />
        <ka-text code="text-7">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text7.value', `Qui assure ces formations ?`)" />
        </ka-text>
        <ka-text code="differents-centres">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.differentsCentres.value', `Différents centres et organismes de formation : organisme de formation, organisme de formation d’apprentis, centres de bilan de compétences, centres d’accompagnement à la VAE, réseaux consulaires peuvent assurer des formations.<br> <br>Mais attention, <strong>toute formation</strong> dispensée par un organisme <strong>ne peut pas par défaut être financée</strong> par les fonds mutualisés.<br> <br>Pour que votre budget issu du fond mutualisé soit débloqué il est nécessaire que l’organisme formateur justifie d’une certification, la certification Qualiopi.`)" />
        </ka-text>
        <ka-image
          code="image-14"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `La qualité des formations Matchers n'est plus à prouver grâce à la certification Qualiopi`
          }"
          value="https://ucarecdn.com/9fe03c47-b503-4580-b528-7801efe7028d/" />
        <ka-text code="text-8">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text8.value', `Qu’est-ce que la certification Qualiopi ? `)" />
        </ka-text>
        <ka-text code="la-reforme-de-la-formation">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.laReformeDeLaFormation.value', `La réforme de la formation de 2018 a créé une <strong>obligation de certification </strong>pour les organismes qui dispensent des formations et qui souhaitent bénéficier des<strong> fonds de la formation professionnelle</strong>.<br> <br><span style='color:#1100A2FF;'><strong>Objectif ?</strong></span><br> <br><strong>👉 Verrouiller l’accès aux fonds mutualisés</strong> pour qu’ils ne soient accessibles qu’à des organismes impliqués dans une démarche qualitative. Effectivement, la certification Qualiopi contraint chaque organisme à mettre un process en place afin de respecter plusieurs normes et de pouvoir vérifier<strong> les formations</strong> effectuées en cas de contrôle. (Exemple : feuilles d'émargement pour attester de la présence du formateur et des apprenants à chaque session)<br> <br><span style='color:#1100A2FF;'><strong>Qui est concerné par la marque « Qualiopi » ?</strong></span><br> <br>👉 Depuis le 1er janvier 2022, la certification qualité est obligatoire pour tous les prestataires d’actions contribuant au développement des compétences qui souhaitent accéder aux fonds publics et mutualisés ; la marque Qualiopi concerne donc tous les prestataires, y compris les formateurs indépendants, dispensant des actions : de formation ; de bilans de compétences ; permettant de faire valider les acquis de l’expérience ; de formation par apprentissage.<br> `)" />
        </ka-text>
        <ka-text code="text-9">
          <h2 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text9.value', `L’accès à la formation pour les start-up, TPE et PME`)" />
        </ka-text>
        <!-- Restez informer ! -->
        <ka-container
          code="restez-informer"
          :xs="{ hidden: null }">
          <ka-text code="ne-ratez-plus-aucune">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.restezInformer.neRatezPlusAucune.value', `Ne ratez plus aucune de nos infos utiles !`)" />
          </ka-text>
          <!-- Formulaire -->
          <ka-container code="formulaire">
            <ka-iframe
              code="iframe"
              :options="{
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                }
              }"
              value="https://share.hsforms.com/1HQYo3aClT_KluQsdc2GYlg2xvix"
              inner />
          </ka-container>
        </ka-container>
        <ka-text code="text-10">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text10.value', `Des financements dédiés aux petites entreprises `)" />
        </ka-text>
        <ka-text code="chaque-opco-propose">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.chaqueOpcoPropose.value', `Chaque OPCO propose des dispositifs de financement mis en place à l’échelle nationale et donc commun à tous les OPCO mais ils peuvent également mettre en place des actions qui leur est propre en correspondance avec les besoins des branches d’activités qui dépendent d’eux. <br> <br>Très souvent ces dispositifs de financement sont rattachés à des <strong>actions de formation</strong> et peuvent quelquefois également porter sur des <strong>activités de conseil</strong>. <br> <br> <br><span style='color:#1100A2FF;'><strong>Le dispositif a absolument connaître :</strong></span>`)" />
        </ka-text>
        <ka-text code="le-plan-de-developpement">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.lePlanDeDeveloppement.value', `Le Plan de Développement des Compétences (PDC)`)" />
        </ka-text>
        <ka-text code="voila-encore-un-changement">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.voilaEncoreUnChangement.value', `Voilà encore un changement issu de la réforme de 2018. Depuis le 1er janvier 2019, le plan de développement des compétences remplace l’ancien plan de formation et simplifie sa mise en œuvre.<br> <br>L’objectif du plan de développement des compétences est d’assurer l’adaptation des salariés à leur poste de travail et veiller au maintien de leur capacité à occuper leur emploi, notamment lorsqu’ils sont confrontés à des évolutions économiques, juridiques, technologiques, environnementales, organisationnelles.<br> <br>Cela peut donc porter sur énormément (voire tous) les sujets et thématiques auxquels vous ou votre équipe pouvez être confrontés.`)" />
        </ka-text>
        <!-- Conteneur -->
        <ka-container code="container-49">
          <!-- Deroule -->
          <ka-container
            code="container-50"
            :options="{
              click: page.container50Click,
              $state: { selected: $isEqual(page.$elements['container-52']?.style.hidden, page.$constants.question1Hidden) }
            }"
            :selected="{ click: page.container50ClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="container-51">
              <ka-text code="les-modalites">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container49.container50.container51.lesModalites.value', `Les modalités`)" />
                <template #xs>
                  <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container49.container50.container51.lesModalites.xs.value', `<strong>Les modalités</strong>`)" />
                </template>
              </ka-text>
              <ka-icon
                code="icon-3"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
          </ka-container>
          <!-- Question 1 -->
          <ka-container
            code="container-52"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <ka-text code="les-montants-disponibles">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container49.container52.lesMontantsDisponibles.value', `Les montants disponibles et les modalités pour accéder à un budget au titre du plan de développement des compétences sont propre à chaque OPCO et même chaque branche d'activité. Le financement peut être indiqué dans la limite d’un plafond horaire ou d’un montant total, il dépend également du nombre d’apprenants, d’heures de formation…etc. <br> <br>Vous l’aurez compris, il n'existe pas de règles qui s'appliquent pour tous. Toutes ces règles changent chaque année et peuvent même évoluer en cours d’année. <br> <br>Tenez-vous informé de vos droits en <a href='https://meetings.hubspot.com/christophe-pramil'><span style='color:#D93174FF;'>prenant contact avec nous </span></a>ou en vous inscrivant à <a href='https://share.hsforms.com/1b5abc90QQtKrGWlmbOKLAQ2xvix'><span style='color:#D93174FF;'>notre newsletter</span></a>.  `)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Conteneur -->
        <ka-container code="container-53">
          <!-- Deroule -->
          <ka-container
            code="container-54"
            :options="{
              click: page.container54Click,
              $state: { selected: $isEqual(page.$elements['container-56']?.style.hidden, page.$constants.question1Hidden) }
            }"
            :selected="{ click: page.container54ClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="container-55">
              <ka-text code="pourquoi-les-regles">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container53.container54.container55.pourquoiLesRegles.value', `Pourquoi les règles ne sont-elles pas les mêmes pour tous ? `)" />
                <template #xs>
                  <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container53.container54.container55.pourquoiLesRegles.xs.value', `<strong>Pourquoi les règles ne sont-elles pas les mêmes pour tous ?</strong>`)" />
                </template>
              </ka-text>
              <ka-icon
                code="icon-4"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
          </ka-container>
          <!-- Question 1 -->
          <ka-container
            code="container-56"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <ka-text code="chaque-opco-adapte">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container53.container56.chaqueOpcoAdapte.value', `Chaque OPCO adapte les dispositifs aux entreprises qu’il représente et toutes les entreprises ne présentent pas les mêmes besoins. Il y a des entreprises où la formation sera majoritairement utilisée pour préserver la sécurité des salariés et d’autres, pour qui la croissance sera au cœur des actions de formation.<br> <br>Chaque convention collective ayant négocié une contribution conventionnelle obligatoire pour les entreprises en plus de la contribution unique peut également négocier la modification de certaines modalités d’accès aux fonds de financement  (exemple : étendre un dispositif à des entreprises de plus de 50 sal) ou même proposer la mise en place d’autres dispositifs.`)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <!-- Conteneur -->
        <ka-container code="container-57">
          <!-- Deroule -->
          <ka-container
            code="container-58"
            :options="{
              click: page.container58Click,
              $state: { selected: $isEqual(page.$elements['container-60']?.style.hidden, page.$constants.question1Hidden) }
            }"
            :selected="{ click: page.container58ClickWhenSelected }">
            <!-- Titre -->
            <ka-container code="container-59">
              <ka-text code="pourquoi-les-petites">
                <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container57.container58.container59.pourquoiLesPetites.value', `Pourquoi les petites entreprises sont-elles avantagées ? `)" />
                <template #xs>
                  <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container57.container58.container59.pourquoiLesPetites.xs.value', `<strong>Pourquoi les règles ne sont-elles pas les mêmes pour tous ?</strong>`)" />
                </template>
              </ka-text>
              <ka-icon
                code="icon-5"
                :options="{ $inheritState: { selected: true } }"
                value="i-fa-solid:angle-down" />
            </ka-container>
          </ka-container>
          <!-- Question 1 -->
          <ka-container
            code="container-60"
            :options="{
              animationIn: `fadeIn`,
              hidden: null
            }">
            <ka-text code="avant-la-reforme-de">
              <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.container57.container60.avantLaReformeDe.value', `Avant la <strong>réforme de la formation professionnelle</strong> de 2018 les fonds mutualisés permettaient de financer des <strong>actions de formation</strong> dans la limite des fonds disponibles à toutes les entreprises. Sans surprise, les grandes entreprises, bien renseignées sur le sujet grâce à leur service RH dédié à la formation professionnelle représentaient la grande majorité des entreprises qui bénéficient de ce budget formation.<br> <br>Depuis le 1er janvier 2019 les fonds mutualisés dédiés au PDC sont directement fléchés vers les entreprises de moins de 50 salariés (voire moins de 249 selon les accords négociés dans les conventions collectives) afin de rééquilibrer l’accès à la formation. Des fonds sont donc exclusivement dédiés aux plus petites entreprises. Elles cotisent moins mais elles bénéficient de plus, c’est un véritable système de mutuelle. `)" />
            </ka-text>
          </ka-container>
        </ka-container>
        <ka-text code="dautres-dispositifs">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.dautresDispositifs.value', `<span style='color:#1100A2FF;'><strong>D’autres dispositifs existent</strong></span>`)" />
        </ka-text>
        <ka-text code="la-prestation-de">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.LaPrestationDe.value', `<strong>👉 La Prestation de Conseil en Ressources Humaines (PCRH) </strong>est dispositif co-financé par les OPCO et la DREETS (Directions régionales de l’économie, de l’emploi, du travail et des solidarités)<br> <br>Il peut financer jusqu’à 6 jours de conseil 2 fois par an pour la convention Syntec (OPCO Atlas) par exemple. Il est activable pour des prestations de conseil liées à la structure et au développement de l’entreprise (ex : process de recrutement, management et leadership...).<br> <br>Ici encore les modalités sont propres à chaque convention collective. N’hésitez pas à nous contacter pour savoir si votre entreprise peut bénéficier de ce financement.`)" />
        </ka-text>
        <ka-text code="le-parcours-strategique">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.LeParcoursStrategique.value', `<strong>👉 Le parcours stratégique </strong>est dispositif spécifique à l'OPCO Atlas et donc réservé aux entreprises qui y sont rattachées. <br> <br>Ce dispositif peut être activé pour une formation vraiment stratégique pour l'entreprise (ex : transformation digitale...) activable tous les 2 ans. Il peut financer minimum 35 heures d'accompagnement et est pris en charge à 75% par l'OPCO jusqu'à 15 000€. `)" />
        </ka-text>
        <ka-text code="text-11">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text11.value', `Les deux règles à retenir pour sécuriser vos budgets de formation `)" />
        </ka-text>
        <ka-text code="les-modalites-des">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.lesModalitesDes.value', `Les modalités des <strong>dispositifs de financement </strong>peuvent changer chaque année, plafond horaire, financement total ou partiel, thématiques éligibles… Le meilleur moyen de rester informé est de s’<span style='color:#D93174FF;'>inscrire à notre newsletter</span> 😉`)" />
        </ka-text>
        <ka-image
          code="image-15"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 1`
          }"
          value="https://ucarecdn.com/911defe6-24a6-4597-9e84-f76cac425bb6/" />
        <ka-text code="premiers-arrives">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.premiersArrives.value', `<span style='background-color:transparent;'>“Premiers arrivés, premiers servis”</span>`)" />
        </ka-text>
        <ka-text code="les-fonds-mutualises">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.lesFondsMutualises.value', `Les fonds mutualisés ne permettent pas de donner. À tout moment les fonds peuvent être appauvris = contraintes supplémentaires. `)" />
        </ka-text>
        <ka-text code="pas-pris-perdu">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.pasPrisPerdu.value', `“Pas pris = perdu”`)" />
        </ka-text>
        <ka-text code="les-fonds-dont-votre">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.lesFondsDontVotre.value', `Les fonds dont votre entreprise peut bénéficier ne sont pas cumulables d’une année sur l’autre. Ils sont définis chaque année en début d’année. `)" />
        </ka-text>
        <ka-text code="text-12">
          <h3 v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.text12.value', `Comment accéder à ces budgets formation ?`)" />
        </ka-text>
        <ka-text code="pour-debloquer-un-financement">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.pourDebloquerUnFinancement.value', `Pour débloquer un financement vous devez déposer une demande sur votre espace OPCO. Il peut s'agir de démarches chronophages pour une entreprise sans service RH. Matchers est un spécialiste des budgets formation. Nous proposons aux entreprises de nous occuper de leurs démarches administratives pour <strong>toute formation</strong> engagée auprès de l'un de nos experts. <br> <br>Plus de 600 profils d'expert dans leur domaine prêts à vous accompagner sur VOTRE cas d'entreprise.  `)" />
        </ka-text>
        <ka-button
          code="prendre-rdv-pour-en"
          :options="{
            ripple: true,
            href: `https://meetings.hubspot.com/christophe-pramil`,
            ariaLabel: `button`,
            click: page.prendreRdvPourEnClick
          }">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.prendreRdvPourEn.value', `Prendre rdv pour en savoir + `)" />
        </ka-button>
        <ka-button
          code="rechercher-un-expert"
          :options="{
            ripple: true,
            href: `/experts`,
            ariaLabel: `button`,
            click: page.rechercherUnExpertClick
          }">
          <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.rechercherUnExpert.value', `Rechercher un expert`)" />
        </ka-button>
        <!-- Partager -->
        <ka-container code="partager">
          <ka-text code="gardons-contact">
            <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.partager.gardonsContact.value', `Gardons contact `)" />
          </ka-text>
          <!-- Reseaux -->
          <ka-container code="reseaux">
            <!-- reseau -->
            <ka-container
              code="reseau"
              :options="{
                href: `https://www.linkedin.com/company/linkedin-com-company-matchers/`,
                ariaLabel: `reseau`,
                click: page.reseauClick
              }">
              <ka-text code="linkedin">
                <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.partager.reseaux.reseau.linkedin.value', `Linkedin`)" />
              </ka-text>
              <!-- Conteneur -->
              <ka-container code="container-61">
                <ka-social-sharing
                  code="social-sharing-1"
                  :options="{
                    socialType: `linkedin`,
                    socialIcon: `i-fa-brands:linkedin-in`
                  }" />
              </ka-container>
            </ka-container>
            <!-- reseau -->
            <ka-container
              code="container-62"
              :options="{ hidden: null }">
              <ka-text code="facebook">
                <span v-html="t('articleFonctionnementDeLaFormationP.articleTemplate.gauche.partager.reseaux.container62.facebook.value', `Facebook`)" />
              </ka-text>
              <!-- Conteneur -->
              <ka-container code="container-63">
                <ka-social-sharing
                  code="social-sharing-2"
                  :options="{
                    socialType: `facebook`,
                    socialIcon: `i-fa-brands:facebook-f`
                  }" />
              </ka-container>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
      <ColonneDroiteArticle instance-class="colonne-droite-article--p80" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { entrepriseBlogFormationProfessionnelleFonctionnement } from './store'
import ArticleEnteteEnBref from '~/components/ArticleEnteteEnBref/index.vue'
import BlocConnaitreMonOpco from '~/components/BlocConnaitreMonOpco/index.vue'
import BlocDropDownDefinitionCodeApe from '~/components/BlocDropDownDefinitionCodeApe/index.vue'
import BlocDropDownDefinitionConventionCo from '~/components/BlocDropDownDefinitionConventionCo/index.vue'
import ColonneDroiteArticle from '~/components/ColonneDroiteArticle/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p80')
const appData = appDataStore()
const page = entrepriseBlogFormationProfessionnelleFonctionnement()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
